export default "__VITE_ASSET__DbD19tbg__"